export enum AppEvent {
  imaLoaded = 'imaLoaded',
  imaStart = 'imaStart',
  initIMA = 'initIMA',
  initLauncher = 'initLauncher',
  initPlacement = 'initPlacement',
  initPlayer = 'initPlayer',
  initVJS = 'initVJS',
  vjsAdsError = 'vjsAdsError',
  vjsEnded = 'vjsEnded',
  vjsError = 'vjsError',
  vjsLoadedData = 'vjsLoadedData'
}

export default AppEvent
